export class Simulacion {
	comercioId: number;
	planId: number;
	monto: number;
}
